import store from "@/store";
import TechnicalSupportModule from "./store";
export default [
  {
    path: "/technical-support",
    component: () => import("./moduleLayout.vue"),
    beforeEnter(to, _, next) {
      if (!store.hasModule("tecSupport"))
        store.registerModule("tecSupport", TechnicalSupportModule);
      next();
    },
    children: [
      {
        path: "users",
        name: "users",
        props: true,
        component: () => import("./pages/users/index.vue"),
        meta: {
          pageTitle: "إدارة المستخدمين",
          slug: "ngo_users",
          breadcrumb: [
            {
              text: "الدعم التقني",
              active: true,
            },
            {
              text: "إدارة المستخدمين",
              active: true,
            },
          ],
        },
      },
    ],
  },
];
